(() => {
  const observeFooter = (bar) => {
    const footer = document.querySelector('footer.site-footer');
    if (bar.teObservedFooter === footer) return;
    bar.teFooterObserver?.disconnect();
    bar.teObservedFooter = footer;
    if (!footer) {
      bar.classList.remove('te-cart-bar--footer-visible');
      return;
    }
    bar.teFooterObserver = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('te-cart-bar--footer-visible', entry.isIntersecting && !(bar.hasAttribute('data-te-early-mobile') && window.matchMedia('(max-width: 767px)').matches));
    }, { threshold: 0 });
    bar.teFooterObserver.observe(footer);
  };
  const setup = (bar) => {
    if (bar.dataset.teCartBarReady) {
      observeFooter(bar);
      return;
    }
    const productInfo = bar.closest('product-info');
    const addButton = bar.querySelector('[data-cart-bar-add-to-cart]');
    const addLabel = bar.querySelector('[data-add-to-cart-text]');
    const buttonPrice = bar.querySelector('[data-cart-bar-button-price]');
    const price = bar.querySelector('[data-product-price]');
    const preorderStatus = bar.querySelector('[data-te-cart-bar-preorder]');
    const sizePicker = [...bar.querySelectorAll('.select-popout__toggle')].find((button) => /taille|size/i.test(button.getAttribute('aria-label') || ''));
    if (!productInfo || !addButton || !addLabel) return;
    bar.dataset.teCartBarReady = 'true';

    const chosenSize = () => productInfo.querySelector('variant-selects [data-te-size-option] input:checked, variant-selects input[name*="Taille"]:checked, variant-selects input[name*="Size"]:checked');
    const sync = () => {
      if (buttonPrice && price) buttonPrice.textContent = price.textContent.trim();
      const preorderProperty = productInfo.querySelector('[data-product-form] [data-te-preorder-property]');
      const preorderShipping = productInfo.querySelector('[data-product-form] [data-te-preorder-shipping]');
      if (preorderStatus) {
        const preorderActive = Boolean(preorderProperty);
        preorderStatus.hidden = !preorderActive;
        const label = preorderStatus.querySelector('[data-te-cart-bar-preorder-label]');
        const shipping = preorderStatus.querySelector('[data-te-cart-bar-preorder-shipping]');
        if (label) label.textContent = preorderActive
          ? (preorderProperty.value || preorderStatus.dataset.tePreorderLabel || 'Précommande')
          : '';
        if (shipping) {
          const shippingLabel = preorderShipping?.dataset.tePreorderShippingLabel
            || preorderStatus.dataset.tePreorderShippingLabel
            || 'Livraison prévue';
          shipping.textContent = preorderActive && preorderShipping?.value
            ? ` · ${shippingLabel} : ${preorderShipping.value}`
            : '';
        }
      }
      const choice = bar.querySelector('[data-te-cart-bar-choice]');
      if (choice) {
        const current = chosenSize();
        let choiceText = sizePicker ? 'Taille non choisie' : '';
        if (current) {
          const value = current.value;
          if (/^X{0,3}[SML]\/X{0,3}[SML]$/.test(value)) {
            const gender = productInfo.querySelector('.te-gender-toggle [aria-pressed="true"]')?.dataset.gender === 'H' ? 'H' : 'F';
            choiceText = `${value.split('/')[gender === 'F' ? 1 : 0]} ${gender === 'F' ? 'femme' : 'homme'} · étiquette ${value}`;
          } else {
            choiceText = `Taille ${value}`;
          }
        }
        choice.textContent = choiceText;
      }
      if (!sizePicker) return;
      const selected = chosenSize();
      bar.classList.toggle('te-cart-bar--size-unselected', !selected);
      const text = sizePicker.querySelector('[data-popout-text]');
      if (!selected) {
        if (text) text.textContent = 'Taille';
        if (!addButton.classList.contains('is-loading')) {
          addLabel.textContent = 'Choisir une taille';
          addButton.disabled = false;
        }
      } else {
        if (text) text.textContent = selected.value;
        if (!addButton.classList.contains('is-loading')) {
          const available = bar.currentVariant?.available !== false && !selected.closest('.sold-out, .unavailable');
          const preorder = preorderProperty;
          const mainLabel = productInfo.querySelector('[data-product-form] [data-add-to-cart-text]');
          const preorderLabel = mainLabel?.childNodes[0]?.textContent.trim();
          addLabel.textContent = available ? (preorder && preorderLabel ? preorderLabel : (window.theme?.strings?.add_to_cart || 'Ajouter au panier')) : (window.theme?.strings?.sold_out || 'Épuisé');
          addButton.disabled = !available;
        }
      }
    };
    bar.addEventListener('click', (event) => {
      if (!event.target.closest('[data-cart-bar-add-to-cart]') || !sizePicker || chosenSize()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      // Desktop (carte flottante) : le sélecteur de la barre est masqué, on ramène aux tailles de la fiche.
      if (window.matchMedia('(min-width: 768px)').matches || (bar.hasAttribute('data-te-early-mobile') && window.matchMedia('(max-width: 767px)').matches)) {
        const choices = productInfo.querySelector('variant-selects');
        if (choices) {
          choices.setAttribute('tabindex', '-1');
          choices.focus({ preventScroll: true });
          choices.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        }
      } else {
        sizePicker.click();
        sizePicker.focus();
      }
    }, true);
    productInfo.addEventListener('click', (event) => {
      if (event.target.closest('.te-gender-toggle button')) requestAnimationFrame(sync);
    });
    productInfo.addEventListener('change', (event) => {
      if (event.target.closest('variant-selects')) requestAnimationFrame(sync);
    });
    if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.sectionId === productInfo.dataset.section || data?.sectionId === productInfo.dataset.originalSection) requestAnimationFrame(sync);
      });
    }
    document.addEventListener('theme:cart:refresh', () => requestAnimationFrame(sync));
    observeFooter(bar);
    sync();
  };
  const setupAll = (root = document) => root.querySelectorAll('cart-bar.te-cart-bar').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupAll());
  else setupAll();
  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
